/**
 * Reducer for tutorials
 */

import { combineReducers } from 'redux-immutable';
import { WAC_TUTORIAL_KEY, wacTutorialReducer } from './tutorial-reducers/wac';
import {
    WRONG_ANSWER_TUTORIAL_KEY,
    wrongAnswerTutorialReducer,
} from './tutorial-reducers/wrongAnswer';
import {
    WATCH_VIDEO_TUTORIAL_KEY,
    watchVideoTutorialReducer,
} from './tutorial-reducers/watchVideo';
import {
    MULTI_PART_QUESTION_TUTORIAL_KEY,
    multiPartQuestionTutorialReducer,
} from './tutorial-reducers/multi-part-question';
import { WAC_FAILED_TUTORIAL_KEY, wacFailedTutorialReducer } from './tutorial-reducers/wac-failed';
import {
    ONBOARDING_VIDEO_TUTORIAL_KEY,
    onboardingVideoTutorialReducer,
} from './tutorial-reducers/onboarding-video';
import {
    PACKAGE_COMPLETE_TUTORIAL_KEY,
    packageCompleteTutorialReducer,
} from './tutorial-reducers/package-complete';
import {
    QUIZ_WRITE_ANSWER_TUTORIAL_KEY,
    quizWriteAnswersTutorialReducer,
} from './tutorial-reducers/quiz-write-answers';
import {
    FIXED_QUESTION_DELIVERY_TUTORIAL_KEY,
    fixedQuestionDeliveryTutorialReducer,
} from './tutorial-reducers/fixed-question-delivery';
import {
    LQD_INITIAL_VIDEO_TUTORIAL_KEY,
    LQDInitialVideoTutorialReducer,
} from './tutorial-reducers/lqd-initial-video';
import {
    DELETED_PACKAGE_TUTORIAL_KEY,
    deletedPackageTutorialReducer,
} from './tutorial-reducers/deleted-package';
import {
    SCD_NEW_FEATURE_TUTORIAL_KEY,
    SCDNewFeatureTutorialReducer,
    SCD_NEW_FILL_TUTORIAL_KEY,
    SCDNewFillTutorialReducer,
    SCD_ONBOARDING_TUTORIAL_KEY,
    SCDOnboardingTutorialReducer,
} from './tutorial-reducers/second-chance-delivery';
import {
    FTQ_TUTORIAL_KEY,
    FTQTutorialReducer,
} from 'phoenix2/state/tutorial/tutorial-reducers/ftq';
import {
    FTQ_TASK_ITEM_TUTORIAL_KEY,
    FTQTaskItemTutorialReducer,
} from './tutorial-reducers/ftq-task-item';
import {
    QUIZ_QUESTION_NUMBERS_TUTORIAL_KEY,
    quizQuestionNumbersTutorialReducer,
} from './tutorial-reducers/quiz-question-numbers';
import {
    QUIZ_WRITE_ANSWER_V2_TUTORIAL_KEY,
    quizWriteAnswersV2TutorialReducer,
} from './tutorial-reducers/quiz-write-answers-v2';
import {
    QUIZ_ENTER_ALL_ANSWERS_TUTORIAL_KEY,
    quizEnterAllAnswersTutorialReducer,
} from './tutorial-reducers/quiz-enter-all-answers';
import {
    QUIZ_NEXT_ANSWER_TUTORIAL_KEY,
    quizNextAnswerTutorialReducer,
} from './tutorial-reducers/quiz-next-answer';
import {
    QUIZ_FINISH_ENTERING_ANSWERS_TUTORIAL_KEY,
    quizFinishEnteringAnswersTutorialReducer,
} from './tutorial-reducers/quiz-finish-entering-answers';
import {
    GAMES_SHOW_WELCOME_ALERT_TUTORIAL_KEY,
    gamesShowWelcomeAlertTutorialReducer,
} from './tutorial-reducers/games-show-welcome-alert';

export const TUTORIAL_KEY = 'tutorial';

/**
 * Combine the reducers for each of the tutorials in the tutorial-reducers
 * directory
 */
export const tutorialReducer = combineReducers({
    [WAC_TUTORIAL_KEY]: wacTutorialReducer,
    [WRONG_ANSWER_TUTORIAL_KEY]: wrongAnswerTutorialReducer,
    [WATCH_VIDEO_TUTORIAL_KEY]: watchVideoTutorialReducer,
    [MULTI_PART_QUESTION_TUTORIAL_KEY]: multiPartQuestionTutorialReducer,
    [WAC_FAILED_TUTORIAL_KEY]: wacFailedTutorialReducer,
    [ONBOARDING_VIDEO_TUTORIAL_KEY]: onboardingVideoTutorialReducer,
    [PACKAGE_COMPLETE_TUTORIAL_KEY]: packageCompleteTutorialReducer,
    [QUIZ_WRITE_ANSWER_TUTORIAL_KEY]: quizWriteAnswersTutorialReducer,
    [FIXED_QUESTION_DELIVERY_TUTORIAL_KEY]: fixedQuestionDeliveryTutorialReducer,
    [LQD_INITIAL_VIDEO_TUTORIAL_KEY]: LQDInitialVideoTutorialReducer,
    [SCD_NEW_FEATURE_TUTORIAL_KEY]: SCDNewFeatureTutorialReducer,
    [SCD_NEW_FILL_TUTORIAL_KEY]: SCDNewFillTutorialReducer,
    [SCD_ONBOARDING_TUTORIAL_KEY]: SCDOnboardingTutorialReducer,
    [DELETED_PACKAGE_TUTORIAL_KEY]: deletedPackageTutorialReducer,
    [FTQ_TUTORIAL_KEY]: FTQTutorialReducer,
    [FTQ_TASK_ITEM_TUTORIAL_KEY]: FTQTaskItemTutorialReducer,
    [QUIZ_QUESTION_NUMBERS_TUTORIAL_KEY]: quizQuestionNumbersTutorialReducer,
    [QUIZ_WRITE_ANSWER_V2_TUTORIAL_KEY]: quizWriteAnswersV2TutorialReducer,
    [QUIZ_ENTER_ALL_ANSWERS_TUTORIAL_KEY]: quizEnterAllAnswersTutorialReducer,
    [QUIZ_NEXT_ANSWER_TUTORIAL_KEY]: quizNextAnswerTutorialReducer,
    [QUIZ_FINISH_ENTERING_ANSWERS_TUTORIAL_KEY]: quizFinishEnteringAnswersTutorialReducer,
    [GAMES_SHOW_WELCOME_ALERT_TUTORIAL_KEY]: gamesShowWelcomeAlertTutorialReducer,
});

export {
    WAC_TUTORIAL_KEY,
    WRONG_ANSWER_TUTORIAL_KEY,
    WATCH_VIDEO_TUTORIAL_KEY,
    WAC_FAILED_TUTORIAL_KEY,
    MULTI_PART_QUESTION_TUTORIAL_KEY,
    QUIZ_WRITE_ANSWER_TUTORIAL_KEY,
    FIXED_QUESTION_DELIVERY_TUTORIAL_KEY,
    LQD_INITIAL_VIDEO_TUTORIAL_KEY,
    SCD_NEW_FEATURE_TUTORIAL_KEY,
    SCD_NEW_FILL_TUTORIAL_KEY,
    SCD_ONBOARDING_TUTORIAL_KEY,
    DELETED_PACKAGE_TUTORIAL_KEY,
    FTQ_TUTORIAL_KEY,
    FTQ_TASK_ITEM_TUTORIAL_KEY,
    QUIZ_QUESTION_NUMBERS_TUTORIAL_KEY,
    QUIZ_WRITE_ANSWER_V2_TUTORIAL_KEY,
    QUIZ_ENTER_ALL_ANSWERS_TUTORIAL_KEY,
    QUIZ_NEXT_ANSWER_TUTORIAL_KEY,
    QUIZ_FINISH_ENTERING_ANSWERS_TUTORIAL_KEY,
    GAMES_SHOW_WELCOME_ALERT_TUTORIAL_KEY,
};
